import { getCampaignInsights } from '../services';
export async function fetchCampaignInsights() {
    const insightsResponse = await getCampaignInsights();
    return formatResponse(insightsResponse);
}
function formatResponse({ data, success }) {
    if (!success)
        return null;
    return {
        endOfLifeActions: formatEndOfLifeActions(data.InsightsEndOffLifeAction),
        categoryActions: formatCategoryActions(data.InsightsCategoryAction),
    };
}
function formatEndOfLifeActions(data) {
    return data.map(insight => ({
        id: insight.id,
        action: insight.action,
        percent: insight.percent,
        link: insight.link,
    }));
}
function formatCategoryActions(data) {
    return data.map(category => ({
        categoryId: category.categoryID,
        link: category.link,
    }));
}
